define('ANSI/UIComponents/Popovers',['jquery', 'eventManager', 'ANSI/Utility/SitecoreUtils'], function ($, eventManager, sitecoreUtils) {
    'use-strict';

    var popovers = {
        init: function () {
            eventManager.subscribe('ModulesLoadedEvent', function () {
                $('[data-toggle="popover"]').popover();
            });

            $(document).on("click", function (e) {
                if ($(e.target).data('toggle') !== 'popover' && $(e.target).parents('.popover.in').length === 0) {
                    $('[data-toggle="popover"]').popover('hide');
                }
            });

            if ($('.tooltip-hero').length > 0) {
                popovers.tooltipHero();
            }
        },
        tooltipHero: function () {
            var btn = $('.tooltip-hero .btn.btn-link');
            $('.tooltip-hero').append(btn);
        }
    };

    if (!sitecoreUtils.prototype.isEditing()) {
        Promise.resolve().then(popovers.init);
    }
});

